import { takeLatest, put, select } from 'redux-saga/effects'

import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { getHrmsMembers, getAllMembers } from './member'
import { fetchGoas } from './goa'
import { getVendors, getPurchasingGroups, getCompanies, getUnits } from './options'
import {
  homePath,
  requestForQuotationDetailPath,
  requestForQuotationEditPath,
  requestForQuotationPath,
  contractEditPath
} from 'routes'

const GET_RFQ_BY_COLLNUM = makeKeys('GET_RFQ_BY_COLLNUM')
const GET_RFQ_DETAIL = makeKeys('GET_RFQ_DETAIL')
const RELOAD_RFQ_BY_COLLNUM = makeKeys('RELOAD_RFQ_BY_COLLNUM')
const FETCH_RFQ = makeKeys('FETCH_RFQ')
const GET_RFQ_GOA_WORK_FLOW_VIEW_MODE = makeKeys('GET_RFQ_GOA_WORK_FLOW_VIEW_MODE')
const GET_RFQ_GOA_WORK_FLOW_EDIT_MODE = makeKeys('GET_RFQ_GOA_WORK_FLOW_EDIT_MODE')
const GET_GOA_ITEM = makeKeys('GET_GOA_ITEM')
const RFQ_ACTION = 'RFQ_ACTION'
const RFQ_UNLOCK = makeKeys('RFQ_UNLOCK')
const CANCEL_RFQ = 'CANCEL_RFQ'
const SAVE_RFQ = 'SAVE_RFQ'
const UPDATE_RFQ = 'UPDATE_RFQ'
const SUBMIT_RFQ = 'SUBMIT_RFQ'
const RESUBMIT_RFQ = 'RESUBMIT_RFQ'
const SAVE_ATTACHMENT_RFQ = 'SAVE_ATTACHMENT_RFQ'
const SAVE_SPECIAL_PR_ATTACHMENT_RFQ = 'SAVE_SPECIAL_PR_ATTACHMENT_RFQ'
const SAVE_QUOTATION_ATTACHMENT_RFQ = 'SAVE_QUOTATION_ATTACHMENT_RFQ'
const CLEAR_RFQ_DATA = 'CLEAR_RFQ_DATA'
const INITIALIZE_RFQ = 'INITIALIZE_RFQ'
const FETCH_RFQ_CATEGORIES = makeKeys('FETCH_RFQ_CATEGORIES')
const GET_RFQ_ERROR_WORKFLOW = makeKeys('GET_RFQ_ERROR_WORKFLOW')
const RFQ_CLEAR_RELOAD = 'RFQ_CLEAR_RELOAD'

export const initializeRFQ = makeAction(INITIALIZE_RFQ, 'isDetail')
export const fetchRFQList = makeAction(FETCH_RFQ.REQUEST, 'dataSearch')
export const rfqAction = makeAction(RFQ_ACTION, 'data', 'history')
export const rfqUnlock = makeAction(RFQ_UNLOCK.REQUEST, 'rfqId')
export const cancelRFQ = makeAction(CANCEL_RFQ, 'data', 'history')
export const saveRFQ = makeAction(SAVE_RFQ, 'data', 'history', 'isSubmit', 'isResubmit')
export const updateRFQ = makeAction(UPDATE_RFQ, 'data', 'history', 'isSubmit', 'isResubmit')
export const clearRFQData = makeAction(CLEAR_RFQ_DATA)
export const submitRFQ = makeAction(SUBMIT_RFQ, 'data', 'history')
export const resubmitRFQ = makeAction(RESUBMIT_RFQ, 'data', 'history')
export const saveAttachmentRFQ = makeAction(SAVE_ATTACHMENT_RFQ, 'data', 'history', 'isSubmit', 'isResubmit')
export const saveSpecialPRAttachmentRFQ = makeAction(SAVE_SPECIAL_PR_ATTACHMENT_RFQ, 'data', 'history', 'isSubmit', 'isResubmit')
export const saveQuatationAttachmentRFQ = makeAction(SAVE_QUOTATION_ATTACHMENT_RFQ, 'data', 'history', 'isSubmit', 'isResubmit')
export const getRFQByCollNum = makeAction(GET_RFQ_BY_COLLNUM.REQUEST, 'collectiveNumber')
export const reloadRFQByCollNum = makeAction(RELOAD_RFQ_BY_COLLNUM.REQUEST, 'collectiveNumber')
export const getRFQDetail = makeAction(GET_RFQ_DETAIL.REQUEST, 'rfqId', 'history', 'isEdit')
export const getRFQGOAWorkFlowViewMode = makeAction(GET_RFQ_GOA_WORK_FLOW_VIEW_MODE.REQUEST, 'rfqId')
export const getRFQGOAWorkFlowEditMode = makeAction(GET_RFQ_GOA_WORK_FLOW_EDIT_MODE.REQUEST, 'data')
export const getGOAItem = makeAction(GET_GOA_ITEM.REQUEST, 'companyCode', 'amount', 'currency')
export const fetchRFQCategories = makeAction(FETCH_RFQ_CATEGORIES.REQUEST)
export const getRFQErrorWorkFlow = makeAction(GET_RFQ_ERROR_WORKFLOW.REQUEST, 'procInstID', 'subProcInstID')
export const clearReload = makeAction(RFQ_CLEAR_RELOAD)

const fetchRFQListSuccess = makeAction(FETCH_RFQ.SUCCESS, 'data')
const rfqUnlockSuccess = makeAction(RFQ_UNLOCK.SUCCESS, 'data')
const getRFQByCollNumSuccess = makeAction(GET_RFQ_BY_COLLNUM.SUCCESS, 'data')
const reloadRFQByCollNumSuccess = makeAction(RELOAD_RFQ_BY_COLLNUM.SUCCESS, 'data')
const getRFQDetailSuccess = makeAction(GET_RFQ_DETAIL.SUCCESS, 'data')
const getRFQGOAWorkFlowViewModeSuccess = makeAction(GET_RFQ_GOA_WORK_FLOW_VIEW_MODE.SUCCESS, 'data')
const getRFQGOAWorkFlowEditModeSuccess = makeAction(GET_RFQ_GOA_WORK_FLOW_EDIT_MODE.SUCCESS, 'data')
const getGOAItemSuccess = makeAction(GET_GOA_ITEM.SUCCESS, 'data')
const fetchRFQCategoriesSuccess = makeAction(FETCH_RFQ_CATEGORIES.SUCCESS, 'data')
const getRFQErrorWorkFlowSuccess = makeAction(GET_RFQ_ERROR_WORKFLOW.SUCCESS, 'data')

const multipartHeader = { 'Content-Type': 'multipart/form-data', }

const initial = {
  rfqList: {},
  sapDetails: { data: null, isReload: false },
  sapDetailReload: { data: null, isReload: false },
  loading: false,
  rfqUnlockStatus: false,
  k2workFlowError: { isError: false, msg: '' },
  goaWorkFlow: { data: [], loading: false },
  rfqGoaItems: { data: [], loading: false },
  rfqCategories: { data: [], loading: false },
}

function* initializeRFQRequest(action) {
  const{isDetail} = action.payload
  try {
    const state = yield select()
    if (!state.rfq.rfqCategories.length) {
      yield put(fetchRFQCategories())
    }
    if (!state.goa.goas.length) {
      yield put(fetchGoas())
    }
    
    yield put(getAllMembers(isDetail))
    // yield put(getHrmsMembers(isDetail))
    if (!state.options.vendors.length) {
      yield put(getVendors())
    }
    if (!state.options.companies.data.length) {
      yield put(getCompanies())
    }
    if (!state.options.purchasingGroups.data.length) {
      yield put(getPurchasingGroups())
    }
    if (!state.options.units.data.length) {
      yield put(getUnits())
    }
  } catch (e) {
    console.log(e)
  }
}

function* getGOAItemRequest(action) {
  const { companyCode, amount, currency } = action.payload
  let param = null
  param = {
    companyCode: companyCode,
    amount: amount,
    currency: currency
  }
  try {
    const response = yield httpGet('rfqs/goaItem', param)
    if (response.status === 200) {
      yield put(getGOAItemSuccess(response.data.map(x => ({ value: x.goaItemCode, text: x.goaItemName }))))
    }
  } catch (e) {
    yield put(getGOAItemSuccess([]))
  }
}

function* fetchRFQListRequest(action) {
  const { dataSearch } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('rfqs', dataSearch)
    if (response.status === 200) {
      yield put(fetchRFQListSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())

    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(appLoaded())
      yield put(fetchRFQList(dataSearch))
    } else {
      yield put(fetchRFQListSuccess({}))
    }
  }
}

function* cancelRFQRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`rfqs/${data.id}/cancel`, { sn: data.sn, comment: data.actionComment })
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Cancel request for quotation success.'))
      yield put(appLoaded())
      history.push(requestForQuotationPath)
    }
  } catch (e) {
    yield put(toastError('Cancel request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* saveRFQRequest(action) {
  const { data, history, isSubmit, isResubmit } = action.payload
  try {
    yield put(appLoading('Save data'))
    const response = yield httpPost('rfqs', data)
    if (response.status >= 200 && response.status < 300) {
      data.id = response.data
      yield put(saveAttachmentRFQ(data, history, isSubmit, isResubmit))
    }
  } catch (e) {
    yield put(toastError('Save request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* updateRFQRequest(action) {
  const { data, history, isSubmit, isResubmit } = action.payload
  try {
    yield put(appLoading('Save data'))
    const response = yield httpPut(`rfqs/${data.id}`, data)
    if (response.status >= 200 && response.status < 300) {
      yield put(saveAttachmentRFQ(data, history, isSubmit, isResubmit))
    }
  } catch (e) {
    yield put(toastError('Save request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* rfqActionRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`rfqs/${data.docId}/actionWorkflow`, data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(requestForQuotationPath)
      }
      yield put(toastSuccess('Action success.'))
    }
  } catch (e) {
    yield put(toastError('Action fail.'))
    yield put(appLoaded())
  }
}

function* rfqUnlockRequest(action) {
  const { rfqId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPut(`rfqs/${rfqId}/unLock`)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      yield put(toastSuccess('Request for quotation unlocked'))
      yield put(rfqUnlockSuccess(response.data.success))
    }
  } catch (e) {
    yield put(rfqUnlockSuccess(false))
    yield put(toastError('Unlock fail.'))
    yield put(appLoaded())
  }
}

function* saveAttachmentRFQRequest(action) {
  const { data, history, isSubmit, isResubmit } = action.payload
  let fileCount = 0
  let countUploading = 1
  let fileName = ''
  try {
    yield put(appLoading('Upload attachment'))
    var attachmentsData = {}
    if (data.pr01) attachmentsData.pr01 = data.pr01
    if (data.pr02) attachmentsData.pr02 = data.pr02
    if (data.pr03) attachmentsData.pr03 = data.pr03
    if (data.pr04) attachmentsData.pr04 = data.pr04
    if (data.pr05) attachmentsData.pr05 = data.pr05
    if (data.pr06) attachmentsData.pr06 = data.pr06
    if (data.pr07) attachmentsData.pr07 = data.pr07
    if (data.pr08) attachmentsData.pr08 = data.pr08
    if (data.pr09) attachmentsData.pr09 = data.pr09
    if (data.pr10) attachmentsData.pr10 = data.pr10
    if (data.pr11) attachmentsData.pr11 = data.pr11
    if (data.pr12) attachmentsData.pr12 = data.pr12
    if (data.pr13) attachmentsData.pr13 = data.pr13
    if (data.pr14) attachmentsData.pr14 = data.pr14
    if (data.pr15) attachmentsData.pr15 = data.pr15
    if (data.rfq04) attachmentsData.rfq04 = data.rfq04

    Object.keys(attachmentsData).forEach(x=>{
      let object = attachmentsData[x]
      if(Array.isArray(object)){
        fileCount += object.length
      }
    })

    let keys = Object.keys(attachmentsData)
    for(let i=0;i<keys.length;i++){
      let keyName = keys[i]
      let object = attachmentsData[keyName]
      if(Array.isArray(object)){
        for(let ii=0;ii<object.length;ii++){
          let fileItem = object[ii]
          fileName = fileItem.path
          yield put(appLoading(`Uploading Attachment File '${fileItem.path}' (${countUploading}/${fileCount})`))
          let file = {}
          file[keyName] = [fileItem]
          yield httpPost(`rfqs/${data.id}/attachments`, file, multipartHeader)
          countUploading++
        }
      }
    }
    
    // if (Object.keys(attachmentsData).length) {
    //   yield httpPost(`rfqs/${data.id}/attachments`, attachmentsData, multipartHeader)
    // }
    yield put(saveSpecialPRAttachmentRFQ(data, history, isSubmit, isResubmit))
  } catch (e) {
    yield put(toastError(`Upload Attachments fail on '${fileName}' (${countUploading}/${fileCount})`,true))
    yield put(appLoaded())
  }
}

function* saveSpecialPRAttachmentRFQRequest(action) {
  const { data, history, isSubmit, isResubmit } = action.payload
  try {
    yield put(appLoading('Upload attachment'))
    if (data.specialPrAttachments) {
      yield httpPost(`rfqs/${data.id}/specialPrAttachments`, data.specialPrAttachments, multipartHeader)
    }
    yield put(saveQuatationAttachmentRFQ(data, history, isSubmit, isResubmit))
  } catch (e) {
    yield put(toastError('Upload special attachment request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* saveQuatationAttachmentRFQRequest(action) {
  const { data, history, isSubmit, isResubmit } = action.payload
  let fileCount = 0
  let countUploading = 1
  let fileName = ''
  try {
    yield put(appLoading('Upload vendor quotation.'))
    if (data.vendorQuatationAttachtments) {
      // yield httpPost(`rfqs/${data.id}/quotationAttachments`, data.vendorQuatationAttachtments, multipartHeader)

      Object.keys(data.vendorQuatationAttachtments).forEach(x=>{
        let object = data.vendorQuatationAttachtments[x]
        if(Array.isArray(object)){
          fileCount += object.length
        }
      })

      let keys = Object.keys(data.vendorQuatationAttachtments)
      for(let i=0;i<keys.length;i++){
        let keyName = keys[i]
        let object = data.vendorQuatationAttachtments[keyName]
        if(Array.isArray(object)){
          for(let ii=0;ii<object.length;ii++){
            let fileItem = object[ii]
            fileName = fileItem.path
            yield put(appLoading(`Uploading Quotation Attachment File '${fileItem.path}' (${countUploading}/${fileCount})`))
            let file = {}
            file[keyName] = [fileItem]
            yield httpPost(`rfqs/${data.id}/quotationAttachments`, file, multipartHeader)
            countUploading++
          }
        }
      }
    }
    if (isSubmit) {
      yield put(submitRFQ(data, history))
    } else if (isResubmit) {
      yield put(resubmitRFQ(data, history))
    } else {
      history.push(requestForQuotationPath)
      yield put(toastSuccess('Save request for quotation success.'))
      yield put(appLoaded())
    }
  } catch (e) {
    yield put(toastError(`Upload quatation attachment fail on '${fileName}' (${countUploading}/${fileCount})`,true))
    yield put(appLoaded())
  }
}

function* submitRFQRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Submit RFQ'))
    const response = yield httpPost(`rfqs/${data.id}/submit`)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      yield put(toastSuccess('Submit request for quotation success.'))
      if (response.data.contractId) {
        history.push(contractEditPath(response.data.contractId))
      } else {
        history.push(requestForQuotationPath)
      }
    }
  } catch (e) {
    yield put(toastError('Submit request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* resubmitRFQRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Submit RFQ'))
    const response = yield httpPost(`rfqs/reSubmit`, { docId: data.id, sn: data.sn, comment: data.actionComment })
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      yield put(toastSuccess('Submit request for quotation success.'))
      history.push(requestForQuotationPath)
    }
  } catch (e) {
    yield put(toastError('Submit request for quotation fail.'))
    yield put(appLoaded())
  }
}

function* reloadRFQByCollNumRequest(action) {
  const { collectiveNumber } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`rfqs/reloadSapDetail/${collectiveNumber}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(reloadRFQByCollNumSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* getRFQByCollNumRequest(action) {
  const { collectiveNumber } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`rfqs/sapDetail/${collectiveNumber}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(getRFQByCollNumSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
    yield put(getRFQByCollNumSuccess(null))
  }
}

function* getRFQDetailRequest(action) {
  const { rfqId, history, isEdit } = action.payload
  try {
    yield put(appLoading())
    let username = localStorage.getItem('username').toLowerCase()
    const response = yield httpGet(`rfqs/${rfqId}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      let status = response.data.status
      let usernameRequester = response.data.requesterUser.toLowerCase()
      let usernameCreator = response.data.createdByUser.toLowerCase()
      if (status === 9) {
        yield put(toastError('Document does not exist or document is deleted'))
        history.push(requestForQuotationPath)
      } else {
        let selectedVendor = `${response.data.selectedVendorCode} ${response.data.selectedVendorName ? `|| ${response.data.selectedVendorName}` : ''}`
        if ((status === 0 && (username === usernameCreator)) ||
          (status === 5 && (username === usernameCreator || username === usernameRequester))) {
          if (isEdit) {
            yield put(getRFQDetailSuccess({ ...response.data, selectedVendor: selectedVendor }))
          } else {
            yield put(getRFQDetailSuccess({ ...response.data, selectedVendor: selectedVendor }))
            history.push(requestForQuotationEditPath(rfqId))
          }
        } else {
          if (!isEdit) {
            yield put(getRFQDetailSuccess({ ...response.data, selectedVendor: selectedVendor }))
          } else {
            history.push(requestForQuotationDetailPath(rfqId))
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(appLoaded())
      yield put(getRFQDetail(rfqId, history, isEdit))
    } else {
      yield put(getRFQDetailSuccess(null))
    }
  }
}

function* getRFQGOAWorkFlowViewModeRequest(action) {
  const { rfqId } = action.payload
  try {
    const response = yield httpGet(`rfqs/goaApproverViewMode`, { id: rfqId })
    if (response.status >= 200 && response.status < 300) {
      yield put(getRFQGOAWorkFlowViewModeSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(appLoaded())
      yield put(getRFQGOAWorkFlowViewMode(rfqId))
    } else {
      yield put(getRFQGOAWorkFlowViewModeSuccess([]))
    }
  }
}

function* getRFQGOAWorkFlowEditModeRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet('rfqs/goaApproverEditMode', data)
    if (response.status >= 200 && response.status < 300) {
      yield put(getRFQGOAWorkFlowEditModeSuccess(response.data))
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getRFQGOAWorkFlowEditModeSuccess([]))
  }
}

function* fetchRFQCategoriesRequest() {
  try {
    const response = yield httpGet(`rfqs/categories`)
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchRFQCategoriesSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(appLoaded())
      yield put(fetchRFQCategories())
    } else {
      yield put(fetchRFQCategoriesSuccess([]))
    }
  }
}

function* getRFQErrorWorkFlowRequest(action) {
  const { procInstID, subProcInstID } = action.payload
  try {
    const response = yield httpGet(`share/workflow/getErrorWorkflow`, { procInstID: procInstID, subProcInstID: subProcInstID })
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        yield put(getRFQErrorWorkFlowSuccess({ isError: false, msg: '' }))
      } else {
        yield put(getRFQErrorWorkFlowSuccess({ isError: true, msg: response.data.message }))
      }
    }
  } catch (e) {
    yield put(getRFQErrorWorkFlowSuccess({ isError: false, msg: '' }))
  }
}

export function* watchRFQSaga() {
  yield takeLatest(INITIALIZE_RFQ, initializeRFQRequest)
  yield takeLatest(CANCEL_RFQ, cancelRFQRequest)
  yield takeLatest(SAVE_RFQ, saveRFQRequest)
  yield takeLatest(UPDATE_RFQ, updateRFQRequest)
  yield takeLatest(SUBMIT_RFQ, submitRFQRequest)
  yield takeLatest(RESUBMIT_RFQ, resubmitRFQRequest)
  yield takeLatest(RFQ_ACTION, rfqActionRequest)
  yield takeLatest(RFQ_UNLOCK.REQUEST, rfqUnlockRequest)
  yield takeLatest(SAVE_ATTACHMENT_RFQ, saveAttachmentRFQRequest)
  yield takeLatest(SAVE_SPECIAL_PR_ATTACHMENT_RFQ, saveSpecialPRAttachmentRFQRequest)
  yield takeLatest(SAVE_QUOTATION_ATTACHMENT_RFQ, saveQuatationAttachmentRFQRequest)
  yield takeLatest(GET_RFQ_BY_COLLNUM.REQUEST, getRFQByCollNumRequest)
  yield takeLatest(RELOAD_RFQ_BY_COLLNUM.REQUEST, reloadRFQByCollNumRequest)
  yield takeLatest(GET_RFQ_DETAIL.REQUEST, getRFQDetailRequest)
  yield takeLatest(GET_RFQ_GOA_WORK_FLOW_VIEW_MODE.REQUEST, getRFQGOAWorkFlowViewModeRequest)
  yield takeLatest(GET_RFQ_GOA_WORK_FLOW_EDIT_MODE.REQUEST, getRFQGOAWorkFlowEditModeRequest)
  yield takeLatest(GET_GOA_ITEM.REQUEST, getGOAItemRequest)
  yield takeLatest(FETCH_RFQ.REQUEST, fetchRFQListRequest)
  yield takeLatest(FETCH_RFQ_CATEGORIES.REQUEST, fetchRFQCategoriesRequest)
  yield takeLatest(GET_RFQ_ERROR_WORKFLOW.REQUEST, getRFQErrorWorkFlowRequest)
}

export default createReducer(initial, state => ({
  [CLEAR_RFQ_DATA]: () => ({
    ...state,
    sapDetails: { data: null, isReload: false },
    sapDetailReload: { data: null, isReload: false },
    rfqUnlockStatus: false
  }),
  [GET_RFQ_BY_COLLNUM.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [GET_RFQ_BY_COLLNUM.SUCCESS]: (data) => ({
    ...state,
    sapDetails: { data: data.data, isReload: true },
    loading: false
  }),
  [RELOAD_RFQ_BY_COLLNUM.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [RELOAD_RFQ_BY_COLLNUM.SUCCESS]: (data) => ({
    ...state,
    sapDetailReload: { data: { ...state.sapDetails, ...data.data }, isReload: true },
    loading: false
  }),
  [GET_RFQ_DETAIL.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [GET_RFQ_DETAIL.SUCCESS]: (data) => ({
    ...state,
    sapDetails: { data: data.data, isReload: false },
    loading: false
  }),
  [GET_RFQ_GOA_WORK_FLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow: { data: [], loading: true }
  }),
  [GET_RFQ_GOA_WORK_FLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow: { data: data.data, loading: false }
  }),
  [GET_RFQ_GOA_WORK_FLOW_EDIT_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow: { data: [], loading: true }
  }),
  [GET_RFQ_GOA_WORK_FLOW_EDIT_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow: { data: data.data, loading: false }
  }),
  [GET_GOA_ITEM.REQUEST]: () => ({
    ...state,
    rfqGoaItems: { data: [], loading: true }
  }),
  [GET_GOA_ITEM.SUCCESS]: (data) => ({
    ...state,
    rfqGoaItems: { data: data.data, loading: false }
  }),
  [FETCH_RFQ.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_RFQ.SUCCESS]: (data) => ({
    ...state,
    rfqList: data.data,
    loading: false
  }),
  [FETCH_RFQ_CATEGORIES.REQUEST]: () => ({
    ...state,
    rfqCategories: { data: [], loading: true },
  }),
  [FETCH_RFQ_CATEGORIES.SUCCESS]: (data) => ({
    ...state,
    rfqCategories: { data: data.data, loading: false },
  }),
  [GET_RFQ_ERROR_WORKFLOW.REQUEST]: () => ({
    ...state,
    k2workFlowError: { isError: false, msg: '' },
  }),
  [GET_RFQ_ERROR_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    k2workFlowError: { isError: data.data.isError, msg: data.data.msg },
  }),
  [RFQ_UNLOCK.SUCCESS]: (data) => ({
    ...state,
    rfqUnlockStatus: data.data,
  }),
  [RFQ_CLEAR_RELOAD]: () => ({
    ...state,
    sapDetails: { data: state.sapDetails.data, isReload: false },
  }),
}))